// @function isEmpty Check wether field is <undefind,null,empty> this will return value accordingly!
export function isEmpty(value: string | undefined) {
  if (typeof value === "string") {
    return value.trim() === "";
  }
  return true;
}

export function isValidPhoneNumber(value: string | undefined) {
  if (typeof value === "string") {
    // Remove non-digit characters
    const numericValue = value.replace(/\D/g, '');
    // Check if the numeric value consists of exactly 10 digits
    return /^\d{10}$/.test(numericValue);
  }
  return false;
}

// @function isValidEmail will provide return if a string is valid 'Email' or not!
export function isValidEmail(email: string) {
  email = email.trim();
  const expression =
    // eslint-disable-next-line no-control-regex
    /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
  return expression.test(String(email).toLowerCase());
}

export function isNumeric(input: string): boolean {
  return /^[0-9]+$/.test(input);
}

export function validateImageBase64(base64String: string) {
  if (!base64String) return false;

  if (!isValidImageFormat(base64String)) {
    return false;
  }

  if (!isValidFileExtension(base64String)) {
    return false;
  }

  if (!isFileSizeWithinLimit(base64String)) {
    return false;
  }

  // All validation checks passed
  return true;
}

export function isValidImageFormat(base64String: string) {
  // Regular expression for matching common image file extensions
  const match = base64String.match(/^data:image\/(\w+);base64,/);
  return !!match;
}

export function isValidFileExtension(base64String: string) {
  // Regular expression for matching common image file extensions
  const allowedExtensions = /(jpeg|jpg|png)$/i;
  const match = base64String.match(/^data:image\/(\w+);base64,/);

  if (!match) {
    return false;
  }

  const fileExtension = match[1].toLowerCase();
  return allowedExtensions.test(fileExtension);
}

export function isFileSizeWithinLimit(base64String: string) {
  // Approximate file size in bytes
  const fileSizeInBytes = (base64String.length * 3) / 4;

  // Maximum allowed file size (2MB)
  const maxSizeInBytes = 10 * 1024 * 1024;

  return fileSizeInBytes <= maxSizeInBytes;
}

export function isObjectNullOrEmpty(obj: any) {
  return obj === null || Object?.keys(obj)?.length === 0;
}

export function isValidDateTime(dateTimeString: string) {
  const parsedDate = new Date(dateTimeString);
  return !isNaN(parsedDate.getTime());
}
